import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { isSameGamePage } from 'utils/js/tab_url_helpers'

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            // SNWEB-2205: switching tabs (or selecting a video) on a game page
            // only changes the trailing URL segments — don't jump to the top.
            if (isSameGamePage(prevProps.location.pathname, this.props.location.pathname)) {
                return
            }
            window.scrollTo(0, 0)
        }
    }

    render() {
        return this.props.children
    }
}

export default withRouter(ScrollToTop)
